'use strict';
var AccountTypeCodes = require('../constants/ApplicationConstants').AccountTypeCodes;
var ProductIds = require('../constants/ApplicationConstants').ProductIds;

module.exports = {

    getInvestorTypeMessageId: function (accountType) {
        return (accountType === AccountTypeCodes.SMSF || accountType === AccountTypeCodes.TRUST) ? 'Trustee ' : 'Investor ';
    },

    isInvestment: function (product) {
        return product === ProductIds.INVESTMENT;
    },

    isAnnuity: function (productId) {
        return productId === ProductIds.COMMINSURE || productId === ProductIds.CHALLENGER;
    },

    isPension: function (product) {
        return product === ProductIds.PENSION;
    },

    isSuper: function (product) {
        return product === ProductIds.SUPER;
    },

    getFormKey: function (accountType, productId) {
        if (!accountType || productId === ProductIds.SUPER || productId === ProductIds.PENSION) {
            return productId;
        }

        return accountType + '-' + productId;
    }
}



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/Products.js